import z from 'zod';
export const transactionModelWithRelations = {
    include: {
        journal: { select: { id: true, code: true, name: true } },
        transactionModelMovements: {
            include: {
                financialAccount: true,
                accountingCategories: { select: { id: true, name: true, parentId: true } },
            },
        },
    },
};
// Dedicated endpoint: toggling activation must not require (nor rewrite) the model's movements,
// unlike the full update.
export const setTransactionModelActiveSchema = z.object({
    isActive: z.boolean(),
});
export const transactionModelMovementDataSchema = z.object({
    financialAccountId: z.number().int().positive('Le compte est requis'),
    accountingCategoryIds: z.array(z.number().int()).optional(),
    description: z.string(),
    transactionType: z.enum(['debit', 'credit']),
});
export const transactionModelDataSchema = z.object({
    name: z.string().min(1, 'Le nom est requis'),
    // Optional journal preset on the template (0 / omitted = none); applied to the entry when the
    // template is selected during manual entry. Nullable FK on TransactionModel.
    journalId: z.number().int().nonnegative().optional(),
    movements: z
        .array(transactionModelMovementDataSchema)
        .min(1, 'Au moins un mouvement est requis')
        .refine((movements) => movements.some((m) => m.transactionType === 'debit') &&
        movements.some((m) => m.transactionType === 'credit'), { message: 'Au moins un débit et un crédit sont requis' }),
});
